import React, { useState, useRef, useEffect } from "react";
import "./ColorPickerInput.css";

const ColorPickerInput = ({ 
  label, 
  description, 
  value, 
  onChange, 
  colorKey 
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const pickerRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Fechar color picker quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showPicker]);

  const handleColorChange = (e) => {
    const newColor = e.target.value;
    setInputValue(newColor);
    onChange(newColor);
  };

  const handleInputChange = (e) => {
    let value = e.target.value;
    
    // Permitir valores com ou sem #
    if (!value.startsWith("#")) {
      value = "#" + value;
    }
    
    setInputValue(value);
    
    // Validar formato hexadecimal
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      onChange(value);
    }
  };

  const isValidColor = /^#[0-9A-F]{6}$/i.test(inputValue);

  return (
    <div className="color-picker-input">
      <div className="color-picker-label-group">
        <label className="color-picker-label">{label}</label>
        {description && (
          <span className="color-picker-description">{description}</span>
        )}
      </div>

      <div className="color-picker-controls" ref={pickerRef}>
        {/* Preview de cor */}
        <div className="color-preview-wrapper">
          <div
            className="color-preview"
            style={{ backgroundColor: isValidColor ? inputValue : "#ccc" }}
            onClick={() => setShowPicker(!showPicker)}
            title="Clique para abrir seletor"
          />
        </div>

        {/* Input de texto */}
        <input
          type="text"
          className={`color-text-input ${!isValidColor ? "invalid" : ""}`}
          value={inputValue}
          onChange={handleInputChange}
          placeholder="#000000"
          maxLength={7}
        />

        {/* Color Picker nativo (oculto) */}
        <input
          type="color"
          className="color-picker-hidden"
          value={isValidColor ? inputValue : "#000000"}
          onChange={handleColorChange}
          ref={(input) => {
            if (showPicker && input) {
              input.click();
            }
          }}
        />
      </div>

      {!isValidColor && inputValue && (
        <span className="color-picker-error">Formato inválido. Use #RRGGBB</span>
      )}
    </div>
  );
};

export default ColorPickerInput;
